import React from 'react';
import CampoEditableTexto from '../../UI/campos/CampoEditableTexto.js';
import CampoEditableFecha from '../../UI/campos/CampoEditableFecha.js';
import CampoEditableFechaCampos from '../../UI/campos/CampoEditableFechaCampos.js';
import * as Campos from '../../constantes/Campos.js';
import styles from './CamposTorneo.module.css';

const CamposTorneoFechas = (props) => {
  const torneo = props.torneo;
  const editar = props.editar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <table className={`${styles.tablaDatos}`}>
      <tbody>
        <tr>
          <td className={`${styles.titulo}`}>Temporada</td>
          <td className={`${styles.valor}`}>
            <CampoEditableTexto
              estilo={`${styles.campoTemporada}`}
              editar={editar}
              nombre={Campos.Torneo.TEMPORADA}
              valor={torneo?.temporada || ''}
              largo={7}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Fecha de Inicio</td>
          <td className={`${styles.valor}`}>
            <CampoEditableFechaCampos
              editar={editar}
              nombre={Campos.Torneo.FECHA_INICIO}
              anio={torneo?.anioInicio}
              mes={torneo?.mesInicio}
              dia={torneo?.diaInicio}
              onChange={onCampoChange}
            />
          </td>
        </tr>

        <tr>
          <td className={`${styles.titulo}`}>Fecha de Fin</td>
          <td className={`${styles.valor}`}>
            <CampoEditableFecha
              editar={editar}
              nombre={Campos.Torneo.FECHA_FIN}
              valor={torneo?.fechaFin}
              onChange={onCampoChange}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default CamposTorneoFechas;
